module.exports = __webpack_public_path__ + "img/amsbannner1.e14f9b20.png";